import type { VerifyHumanityOutput } from '@zealy/schemas';

import { apiV2 } from '../services';

export const verifyHumanity = async (): Promise<VerifyHumanityOutput> => {
  const response = await apiV2.antibot.verifyHumanity();

  if (response.status !== 200) {
    throw new Error(`Failed to verify humanity: ${response.body}`);
  }

  return response.body;
};
